module.exports = __webpack_public_path__ + "images/bourguignon9063e294dd5a54f97040a4e5b6c61fed.png";